import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 12px;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.palette.background.lightBlur};
  gap: 10px;
  cursor: pointer;

  & + & {
    margin-top: 10px;
  }
`;

export const GameImage = styled.img`
  width: 86px;
  height: 86px;
  object-fit: cover;
  border-radius: 10px;
`;

export const Infos = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
`;

export const TitlePlatformWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`;

export const GameName = styled.p`
  font-family: 'Russo One';
  font-style: normal;
  font-weight: 400;
  font-size: 1.58538rem;
  line-height: 19px;
  color: ${({ theme }) => theme.palette.text.white};
`;

export const Platforms = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 5px;
`;

export const PlatformLabel = styled.p`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 0.99086rem;
  line-height: 17px;
  text-align: right;
  letter-spacing: 0.106698px;
  color: ${({ theme }) => theme.palette.text.white};
`;

export const PlatformIcon = styled.img`
  width: 11px;
  height: 11px;
  object-fit: contain;
`;

export const ValueIconWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ValueWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const ValueLabel = styled.p`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 0.99086rem;
  line-height: 12px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.palette.text.white};
  text-transform: uppercase;
`;

export const Value = styled.p`
  font-family: 'Russo One';
  font-style: normal;
  font-weight: 400;
  font-size: 2.08081rem;
  line-height: 25px;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.palette.text.white};
`;

export const CoinIcon = styled.img`
  width: 36px;
  height: 36px;
  object-fit: contain;
`;
